import React from 'react';
import { Grid } from '@material-ui/core';

import { CutoutModel } from '../../../../../Models/CutoutModel';
import { KeywordModel } from '../../../../../Models/KeywordModel';
import { FilterChipsSearchField } from '../../../../../shared/components/FilterChipsSearchField';
import { KeywordListForClient } from '../../../../../shared/components/KeywordListForClient';
import { EditAction } from '../../../../../shared/enum/EditAction';
import { ClientContext } from '../../../ClientContext';

interface ICutoutKeywordsProps {
    cutout: CutoutModel,
    setCutout: (cutout: CutoutModel) => void,
}

export function CutoutKeywords({ cutout, setCutout }: ICutoutKeywordsProps) {
    const clientContext = React.useContext(ClientContext);

    const [searchKeyword, setSearchKeyword] = React.useState<string>('');

    const sortKeywords = (list: KeywordModel[]) => {
        const noneElements = list.filter(x => x.description.toLowerCase() === 'nenhum');
        let otherElements = list.filter(x => x.description.toLowerCase() !== 'nenhum');
        otherElements.sort((a,b) => a.description.localeCompare(b.description));

        if (noneElements.length > 0) {
            otherElements = [...noneElements, ...otherElements];
        }

        return otherElements;
    };

    const handleSelectKeyword = (keyword: KeywordModel) => {
        const currentKeyword = { ...keyword };
        const selectedKeywords = [...cutout.keywords];

        const index = selectedKeywords.findIndex(k => k.id === currentKeyword.id || k.description === currentKeyword.description);

        if (index >= 0 && selectedKeywords[index].editAction == EditAction.DELETE)
            selectedKeywords[index].editAction = EditAction.NONE;
        else {
            currentKeyword.editAction = EditAction.SELECTED;
            selectedKeywords.push(currentKeyword);
        }

        const sortedKeywords = sortKeywords(selectedKeywords);

        setCutout({ ...cutout, keywords: sortedKeywords });
    };

    const handleDeselectKeyword = (keyword: KeywordModel) => {
        const currentKeyword = { ...keyword };
        const selectedKeywords = [...cutout.keywords];

        const index = selectedKeywords.findIndex(k => k.id === currentKeyword.id || k.description === currentKeyword.description);

        if (selectedKeywords[index].editAction == EditAction.SELECTED)
            selectedKeywords.splice(index, 1);
        else if (selectedKeywords[index].editAction == EditAction.NONE)
            selectedKeywords[index].editAction = EditAction.DELETE;

        const sortedKeywords = sortKeywords(selectedKeywords);

        setCutout({ ...cutout, keywords: sortedKeywords });
    };

    return (
        <Grid
            container
            direction="row"
            spacing={3}>

            <Grid item xs={12} sm={6}>
                <FilterChipsSearchField
                    key="cutout-keywords-search-field"
                    searchText={ searchKeyword }
                    setSearchText={ setSearchKeyword } />
            </Grid>

            <Grid item xs={12} sm={12}>
                <KeywordListForClient
                    key="cutout-client-keywords"
                    selectedKeywords={ cutout.keywords }
                    keywordList={ [ ...clientContext.keywords ] }
                    onSelectKeyword={ handleSelectKeyword }
                    onDeselectKeyword={ handleDeselectKeyword }
                    searchTextFilter={ searchKeyword } />
            </Grid>

        </Grid>
    );
}